export const isAdmin = (user) => user?.permissions?.includes('admin_panel');
export const isSupervisor = (user) => user?.permissions?.includes('supervisor_panel');
export const isSupervisorOrAdmin = (user) => user?.permissions?.includes('supervisor_panel') || user?.permissions?.includes('admin_panel');
export const hasPermission = (user, perm) => user?.permissions?.includes(perm);
